import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    ISingleUserType,
    IUsersType,
    Users,
    User,
} from "../../types/dnoInterface/dnoUserSuggestionTypes"

export const dnoUserSuggestionMapper = {
    /**
     * Maps the response from the User Suggestion API to the IUsersType interface.
     * @param response - The response from the API.
     * @returns The mapped object of type IUsersType.
     */
    mapUserSuggestion: (response: unknown): IUsersType => {
        const res = tsIoValidate<IUsersType>(
            Users,
            response,
            "Error mapping user suggestion data."
        )
        return res
    },

    mapSingleUser: (response: unknown): ISingleUserType => {
        const res = tsIoValidate<ISingleUserType>(
            User,
            response,
            "Error mapping single user data."
        )
        return res
    },
}
